import React from "react";
import "./AboutMaple.css";
import mapleTopLight from "../../assets/images/maple-top-light.png";
import "rsuite/dist/rsuite.min.css";

const getUserDetails = () => {
  const user = JSON.parse(sessionStorage.getItem('user'));
  return user ? `${user.name}` : 'Unknown User';
};

const AboutMaple = () => {
  const userName = getUserDetails();
  return (
    <div className="login-main-container" data-testid="about-maple">
      <div className="login-container">
        <div>
          <img alt="maple-logo" src={mapleTopLight} />
        </div>
        <div className="info-text">Massive Analytics Platform for Logging Events</div>
        <br />
        <br />
        <table className="info-table">
          <tbody>
            <tr>
              <td className="info-text">User: </td>
              <td>{userName}</td>
            </tr>
            <tr>
              <td className="info-text">UI Version:</td>
              <td>v1.0.0</td>
            </tr>
            <tr>
              <td className="info-text">API Version:</td>
              <td>v2.0.0</td>
            </tr>
            <tr>
              <td className="info-text">API Endpoint:</td>
              <td>https://api.maple.comcast.net</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AboutMaple;
